export default "__VITE_ASSET__D2ZZn3Kr__"